/**
 * Return a new object containing only `keys` that are present in `source`.
 * Used by edit-mode commit paths (Tick / rich-text Save) so a commit persists
 * ONLY the committed cells — `updateSheetData`'s shallow merge then leaves every
 * other (possibly mid-edit) field at its committed value. A key absent from
 * `source` is omitted entirely (never written as `undefined`); a key present with
 * a `null` value is kept (a user-cleared cell is a real change).
 */
export function pickSubset(source: Record<string, any>, keys: string[]): Record<string, any> {
  const out: Record<string, any> = {};
  
  for (const key of keys) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      out[key] = source[key];
    }
  }
  return out;
}
